/**
 * Auto-generated version file - do not edit manually
 * Generated from package.json
 */

export const VERSION = '1.0.74';
